import { render, staticRenderFns } from "./SimpleMessagesIndex.vue?vue&type=template&id=1124be80&scoped=true&"
import script from "./SimpleMessagesIndex.vue?vue&type=script&lang=js&"
export * from "./SimpleMessagesIndex.vue?vue&type=script&lang=js&"
import style0 from "./SimpleMessagesIndex.vue?vue&type=style&index=0&id=1124be80&scoped=true&lang=scss&"
import style1 from "./SimpleMessagesIndex.vue?vue&type=style&index=1&id=1124be80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1124be80",
  null
  
)

export default component.exports